<script setup lang="ts">
    import BaseSlider from '@/components/BaseSlider.vue';
    import { useSpacingControl } from '@/composables/useSpacingControl';
    import { toRef } from 'vue';
    import type { ITextField } from '@/typescript/interfaces/ITextField';

    const props = defineProps<{
        field: ITextField;
        max: string;
        min: string;
        spacingType: 'characterSpacing' | 'lineSpacing';
        title?: string;
    }>();

    const { spacingValue } = useSpacingControl(
        toRef(() => props.field),
        toRef(() => props.spacingType),
    );
</script>

<template>
    <div class="flex flex-col gap-4 pb-6 pt-2">
        <h2 class="text-center text-lg font-medium">{{ props.title }}</h2>

        <div class="mx-auto w-full max-w-sm rounded-md bg-white p-4">
            <div class="flex items-center gap-4">
                <BaseSlider
                    v-model="spacingValue"
                    :min="props.min"
                    :max="props.max"
                    label-id="mobile-spacing-slider"
                    :show-value="false"
                    class="flex-1"
                />
                <span class="flex h-10 w-10 flex-none items-center justify-center rounded border border-black bg-white">
                    {{ spacingValue }}
                </span>
            </div>
        </div>
    </div>
</template>
